var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defaultContentView"},[_c('h1',{staticClass:"display-1 mb-3 primary--text"},[_vm._v(" Welcome! ")])])}]

export { render, staticRenderFns }